<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.user-detail')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4" title="비밀번호 수정">
          <b-form @submit.prevent="onSubmitEdit" class="av-tooltip tooltip-label-bottom">
            <b-row>

              <!--              <b-colxx sm="12">-->
              <!--                <b-form-group label-cols="2" horizontal label="아이디" class="error-l-250">-->
              <!--                  <b-form-input v-model="info.username" readonly></b-form-input>-->
              <!--                </b-form-group>-->
              <!--              </b-colxx>-->

              <!--              <b-colxx sm="12">-->
              <!--                <b-form-group label-cols="2" horizontal label="이름" class="error-l-250">-->
              <!--                  <b-form-input type="text" v-model="$v.fullName.$model" :state="!$v.fullName.$error"></b-form-input>-->
              <!--                  <b-form-invalid-feedback v-if="!$v.fullName.required">{{$t('user.required-name')}}-->
              <!--                  </b-form-invalid-feedback>-->
              <!--                </b-form-group>-->
              <!--              </b-colxx>-->

              <b-colxx sm="12">
                <b-form-group label-cols="2" horizontal label="비밀번호" class="error-l-250">
                  <b-row>
                    <b-col>
                      <b-form-input type="password" v-model="$v.password.$model" placeholder="현재 비밀번호를 입력해주세요."
                                    :state="!$v.password.$error"></b-form-input>
                      <b-form-invalid-feedback v-if="!$v.password.required">{{ $t('user.required-password') }}
                      </b-form-invalid-feedback>
                    </b-col>
                    <!--                    <b-col>-->
                    <!--                      <b-button @click="checkPassword" variant="outline-primary">비밀번호변경</b-button>-->
                    <!--                    </b-col>-->
                  </b-row>
                </b-form-group>
              </b-colxx>

              <!--              <b-colxx sm="12" v-show="changePass">-->
              <b-colxx sm="12">
                <b-form-group label-cols="2" horizontal class="error-l-250">
                  <b-row>
                    <b-col>
                      <b-form-input type="password" v-model="$v.newPassword.$model" placeholder="변경할 비밀번호를 입력해주세요."
                                    :state="!$v.newPassword.$error"></b-form-input>
                      <b-form-invalid-feedback v-if="!$v.newPassword.required">{{ $t('user.required-newPassword') }}
                      </b-form-invalid-feedback>
                      <b-form-invalid-feedback v-if="!$v.newPassword.passCheck">8~16자 영문 대 소문자, 숫자, 특수문자를 사용 가능합니다.
                      </b-form-invalid-feedback>
                    </b-col>
                    <b-col>
                      <b-form-input type="password" v-model="$v.newPasswordConfirm.$model" placeholder="비밀번호를 다시 한번 입력해 주세요."
                                    :state="!$v.newPasswordConfirm.$error"></b-form-input>
                      <b-form-invalid-feedback v-if="!$v.newPasswordConfirm.required">
                        {{ $t('user.required-newPassword-confirm') }}
                      </b-form-invalid-feedback>
                      <b-form-invalid-feedback v-else-if="!$v.newPasswordConfirm.sameAsPassword">
                        {{ $t('user.password-identical') }}
                      </b-form-invalid-feedback>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-colxx>

              <!--              <b-colxx sm="12">-->
              <!--                <b-form-group label-cols="2" horizontal label="휴대폰" class="error-l-250">-->
              <!--                  <b-form-input v-model="phoneNumber" type="text" :state="!$v.phoneNumber.$error"></b-form-input>-->
              <!--                  <b-form-invalid-feedback v-if="!$v.phoneNumber.required">{{$t('user.required-phone')}}-->
              <!--                  </b-form-invalid-feedback>-->
              <!--                </b-form-group>-->
              <!--              </b-colxx>-->
            </b-row>
            <div class="text-center">
              <b-button type="submit" variant="primary" size="md">비밀번호 수정</b-button>
            </div>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>
<script>

import {
  mapGetters,
  mapActions
} from "vuex";

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import {
  validationMixin
} from "vuelidate";
import api from '../../constants/api'

const {
  required,
  maxLength,
  minLength,
  numeric,
  email,
  helpers,
  sameAs
} = require("vuelidate/lib/validators");

const passCheck = helpers.regex('passCheck', /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^*()\-_=+\\\|\[\]{};:\'",.<>\/?]).{8,16}$/);
export default {
  components: {
    'v-select': vSelect,
  },
  props: [],
  mixins: [validationMixin],
  validations: {
    // fullName: {
    //   required
    // },
    password: {
      required
    },
    newPassword: {
      required,
      passCheck
    },
    newPasswordConfirm: {
      required,
      sameAsPassword: sameAs('newPassword')
    },
    // phoneNumber: {
    //   required,
    //   numeric
    // }

  },
  data() {
    return {
      changePass: false,
      password: '',
      newPassword: '',
      newPasswordConfirm: '',
      fullName: '',
      phoneNumber: '',
      emailAgree: false,
      smsAgree: false
    }
  },
  computed: {
    ...mapGetters(['info', 'currentUser', 'siteName', 'resetPasswordSuccess'])
  },
  mounted() {
    console.log(this.currentUser);
  },
  methods: {
    ...mapActions(["resetPassword"]),

    onCancel() {
      this.$router.back()
    },


    onSubmitEdit() {
      this.$v.$touch();
      console.log(this.password);
      console.log(this.$v);

      if(!this.$v.$anyError) {
        console.log("onSubmitEdit");
        this.resetPassword({oldPassword: this.password, newPassword: this.newPasswordConfirm});
      }
    },

  }
  , watch: {
    resetPasswordSuccess(val) {
      if(val) {
        this.$notify(
          "success",
          "Reset Password Success",
          "비밀번호가 변경되었습니다.", {
            duration: 3000,
            permanent: false
          }
        );
        this.$router.push(`/${this.siteName}/booking/booking-visit`);
      }
    }

  }
}
</script>
